import { render, staticRenderFns } from "./ConfigBackupAndRecover.vue?vue&type=template&id=6199920f&scoped=true&"
import script from "./ConfigBackupAndRecover.vue?vue&type=script&lang=js&"
export * from "./ConfigBackupAndRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199920f",
  null
  
)

export default component.exports